<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="individus"
        class="elevation-1"
        pagination.sync="pagination"
        item-key="id"
        dense
        v-if="individus.length > 0"
        sort-by="user"
      >
        <template
          v-for="(header, index) in headers"
          v-slot:[`item.${header.value}`]="{ item }"
        >
          <div :key="index" class="text-center">
            <div v-if="header.text == 'Utilisateur'">
              {{ item[header.value] }}
            </div>
            <div v-else-if="header.text == 'Action'">
              <v-btn @click="supprimeUtilisateur(item)" icon color="error" dense
                ><v-icon>mdi-delete-variant</v-icon></v-btn
              >
            </div>
            <div v-else>
              <v-checkbox
                class="my-n4 py-n4"
                dense
                :input-value="item.roles[index - 1].value"
                @change="changer(item, header.value, index - 1)"
              ></v-checkbox>
            </div>
          </div>
        </template>
      </v-data-table>
      <div class="text-center">
        <br /><v-btn color="success" @click="sauvegarde"
          >Sauvegarder les changements de rôles</v-btn
        >
        <v-btn color="success" @click="showDialogAjout"
          >Ajouter un utilisateur</v-btn
        >
      </div>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="500px"
        transition="dialog-transition"
      >
        <div class="text-center">
          <v-progress-circular :value="20"></v-progress-circular>
        </div>
      </v-dialog>
      <v-dialog
        v-model="dialogAjout"
        persistent
        max-width="500px"
        transition="dialog-transition"
        ><BaseBlock>
          <v-form
            v-model="ajoutValid"
            lazy-validation
            ref="formAjout"
            @submit.prevent
          >
            <v-autocomplete
              label="recherche par nom de famille"
              item-text="displaynameUID"
              :search-input.sync="search"
              :items="users"
              v-model="user"
              hide-no-data
              hide-selected
              required
              autocomplete
              :rules="[(value) => !!value || 'champ requis.']"
              return-object
            ></v-autocomplete>
            <div class="text-center">
              <v-btn
                color="success"
                @click="ajoutUtilisateur"
                :disabled="!ajoutValid"
                >Ajouter</v-btn
              >&nbsp;<v-btn color="info" @click="annulerAjout">annuler</v-btn>
            </div>
          </v-form>
        </BaseBlock>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ApiUtilisateurRepository from "@/repositories/ApiUtilisateurRepository";
import ApiRoleRepository from "@/repositories/ApiRoleRepository";
import ApiAnnuaireRepository from "@/repositories/ApiAnnuaireRepository";
import BaseBlock from "@/components/base/BaseBlock";

export default {
  components: { BaseBlock },
  data() {
    return {
      headers: [{ text: "Utilisateur", value: "user", align: "center" }],
      individus: [],
      utilisateurs: null,
      droits: null,
      tableauHTML:
        "<template v-slot:item.grh='{item}'>" +
        "<v-checkbox v-model='item.GRH' :value='item.GRH'></v-checkbox>" +
        "</template>",
      divation: "<div class='red'>cocuou</div>",
      calc: null,
      dialog: false,
      dialogAjout: false,
      users: [],
      user: null,
      name: null,
      ajoutValid: false,
      search: null,
    };
  },
  async mounted() {
    this.utilisateurs = await ApiUtilisateurRepository.getUtilisateurs();
    console.log(this.utilisateurs);

    this.droits = await ApiRoleRepository.getRoles();
    this.droits = this.droits.sort(function (a, b) {
      var x = a.id < b.id ? -1 : 1;
      return x;
    });
    this.droits.forEach((element) => {
      if (element.label != "Superadmin") {
        this.headers.push({
          text: element.name,
          value: element.label,
          sortable: false,
          align: "center",
        });
      }
    });
    this.headers.push({ text: "Action", value: "poubelle", align: "center" });
    this.utilisateurs.forEach((element) => {
      this.ajoutIndividu(element);
    });
  },
  watch: {
    search: async function (val) {
      this.users = await ApiAnnuaireRepository.getBySearch(val);
      await this.users.forEach(
        (element) =>
          (element.displaynameUID =
            element.displayComplet + " - " + element.uidLdap)
      );
    },
  },
  methods: {
    changer(item, value, index) {
      if (item.roles[index].value) item.roles[index].value = false;
      else item.roles[index].value = true;
    },
    async sauvegarde() {
      this.dialog = true;
      var donneeID = [];
      this.individus.forEach((utilisateur) => {
        donneeID.push({ id: utilisateur.id });
        var index1 = donneeID.length - 1;
        donneeID[index1].roles = [];
        utilisateur.roles.forEach((role) => {
          var index = donneeID.length - 1;
          if (role.value) donneeID[index].roles.push(role.id);
        });
      });

      this.dialog = false;
      await ApiUtilisateurRepository.updateRoles(donneeID);
    },
    showDialogAjout() {
      this.dialogAjout = true;
    },

    annulerAjout() {
      this.user = null;
      this.name = null;
      this.dialogAjout = false;
      this.$refs.formAjout.reset();
    },
    async ajoutUtilisateur() {
      if (this.$refs.formAjout.validate()) {
        var contient = false;
        this.utilisateurs.forEach((element) => {
          if (element.uidLdap == this.user.uidLdap) {
            contient = true;
          }
        });
        if (!contient) {
          let utilisateur = await ApiUtilisateurRepository.saveUtilisateur(
            this.user
          );

          this.ajoutIndividu(utilisateur);
          this.annulerAjout();
        } else {
          this.$toast.warn("L'utilisateur est déjà présent dans la base !");
        }
      }
    },
    async supprimeUtilisateur(item) {
      await ApiUtilisateurRepository.deleteUtilisateur(item.id);
      this.individus = this.individus.filter((element) => element != item);
    },
    ajoutIndividu(element) {
      var superAdmin = false;
      var int = 0;
      element.roles.forEach((roleJSON) => {
        int++;
        if (roleJSON.label == "Superadmin") {
          superAdmin = true;
        }
        if (int > 1) {
          superAdmin = false;
        }
      });
      if (!superAdmin) {
        this.individus.push({
          user: element.nom + " " + element.prenom,
          id: element.id,
        });
        let index = this.individus.length - 1;
        this.individus[index].roles = [];
        var a;
        var i = 0;
        for (var role in this.droits) {
          a = this.droits[role].label;
          if (this.droits[role].label != "Superadmin") {
            if (element.roles.length > i) {
              if (element.roles[i].label == a) {
                this.individus[index].roles.push({
                  id: this.droits[role].id,
                  value: true,
                });
                i += 1;
              } else
                this.individus[index].roles.push({
                  id: this.droits[role].id,
                  value: false,
                });
            } else {
              this.individus[index].roles.push({
                id: this.droits[role].id,
                value: false,
              });
            }
          }
        }
      }
    },
  },
};
</script>

<style>
.v-input__slot {
  align-items: center;
  justify-content: center;
}
</style>
